#import "../fragments/email-sequence-template-fragment.graphql"

mutation DeleteEmailSequenceTemplate($sequenceTemplate: EmailSequenceTemplateDeleteInput!) {
    emailSequenceTemplateDelete(input: $sequenceTemplate) {
        emailSequenceTemplate {
            ...EmailSequenceTemplate
        }
    }
}
